// src/components/SEO.jsx
import React from 'react';
import { useSEO } from '../context/SEOContext';
import {Helmet} from "react-helmet-async";

const SEO = ({
                 title,
                 description,
                 keywords,
                 canonical,
                 ogImage,
                 ogType,
                 twitterCard,
                 structuredData,
                 noindex = false,
                 nofollow = false,
                 breadcrumbs = []
             }) => {
    const { seoData, generateBreadcrumbSchema } = useSEO();

    const metaTitle = title || seoData.title;
    const metaDescription = description || seoData.description;
    const metaKeywords = keywords || seoData.keywords;
    const metaCanonical = canonical || seoData.canonical || window.location.href;
    const metaOgImage = ogImage || seoData.ogImage;
    const metaOgType = ogType || seoData.ogType;
    const metaTwitterCard = twitterCard || seoData.twitterCard;

    const robotsMeta = [];
    if (noindex) robotsMeta.push('noindex');
    if (nofollow) robotsMeta.push('nofollow');
    const robotsContent = robotsMeta.length > 0 ? robotsMeta.join(', ') : 'index, follow';

    const breadcrumbSchema = breadcrumbs.length > 0 ? generateBreadcrumbSchema(breadcrumbs) : null;

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <meta name="robots" content={robotsContent} />

            {/* Canonical URL */}
            <link rel="canonical" href={metaCanonical} />

            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content={metaOgType} />
            <meta property="og:url" content={metaCanonical} />
            <meta property="og:image" content={metaOgImage} />
            <meta property="og:site_name" content="Chema Platform" />

            {/* Twitter Card Meta Tags */}
            <meta name="twitter:card" content={metaTwitterCard} />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaOgImage} />
            <meta name="twitter:site" content="@chemaplatform" />

            {/* Additional Meta Tags */}
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#2563eb" />
            <meta name="msapplication-TileColor" content="#2563eb" />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>

            {breadcrumbSchema && (
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbSchema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;